import { namespace } from './namespace';

export const UPDATE_YEAR = namespace + '/UPDATE_YEAR';
export const VALIDATE_YEAR = namespace + '/VALIDATE_YEAR';
export const VALIDATE_YEAR_FAILURE = namespace + '/VALIDATE_YEAR_FAILURE';
export const SAVE_YEAR = namespace + '/SAVE_YEAR';
